export const postcodeRegEx = /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i;
export const halfPostcodeRegEx = /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9]|[A-Z][0-9][0-9]){1}([ 0-9A-Z]{1,4})?$/i;

export const emailRegEx = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);
